/**
 * Copyright (c) 2019, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react';
import { Link } from 'react-router-dom';
import Localized from '../../../shared/components/Localized';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from '../Button';

const Wrapper = styled.div`
  text-align: center;
  background-color: white;
  min-height: 550px;
  margin: 0.75rem;
  padding-bottom: 1rem;
  border-radius: 0.25rem;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 2px 0px;
  height: 100%;
`;
const Content = styled.p`
  margin: 1rem 0;
`;
const Heading = styled.div`
  font-size: 8rem;
  font-family: SalesforceSans-Thin;
  letter-spacing: -0.125rem;
  opacity: 0.2;
  padding-top: 5rem;
  line-height: 7rem;
`;
const StyledLink = styled(Link)`
  padding-top: 1rem;
`;

/**
 * This component renders an error page with a search button
 * It takes in 2 props at the moment
 *  1. targetUrl: The url for the page you want to take the user to
 *  2. buttonText: The text for the button
 *  3. messageModelKey: The model for which the error is displayed. It
 *     can be used to display a different Localized message
 * @param {object} props
 */
export default function ErrorWithOptions(props) {
  const { targetUrl, buttonText, messageModelKey } = props;
  return (
    <Wrapper>
      <Heading>
        <Localized
          modelName="errorwithoptions"
          modelKey="invalidUrl"
          modelAttribute="label"
        />
      </Heading>
      <Content>
        <Localized
          modelName="errorwithoptions"
          modelKey={messageModelKey}
          modelAttribute="label"
        />
        <br />
      </Content>
      <StyledLink to={targetUrl}>
        <Button theme="brand">{buttonText}</Button>
      </StyledLink>
    </Wrapper>
  );
}
ErrorWithOptions.propTypes = {
  targetUrl: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  messageModelKey: PropTypes.string.isRequired
};
